import React, { useState,useEffect } from 'react';
import {
    Button,Table,Layout,
    Row,Col,Modal,
} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
const { Content } = Layout;
import { getSoilLayer,FetchanalysisDetail,DLAnalysisDetail } from '@/util/Request';
import moment from 'moment';
import IF from '@/components/IF';
import {
    DownloadPdf,
    DownloadXls,
    SoilCloseIcon,
    SoilProfileEditProfileIcon
} from '@/resource/IconComponentSets';
import { RootState } from '@/redux';
import './index.less';
interface TitleType {
    sampleCode?:string;
    profileName?:string;
    layerName:string;
    star:any;
    end:any;
}
interface IProps {
    children?: React.ReactElement | React.ReactElement[] | string
    className?: string
    edit?: (param:string) => void
    visible?:boolean
    editItem: any
    onCancel?: () => void
    childChangeIsShowPreviewModal?: ()=>void
}
const DetailModel = (props:IProps) => {
    const {userInfo} = useSelector((state: RootState) =>
        state.soilUser);
    const dispatch = useDispatch();
    // const {soilPropertyList,methodList,extList} = useSelector((state: RootState) =>
    //     state.soilAnalysesData);
    const [detail,setDetail] = useState([]);
    const [detailTitle,setDetailTitle] = useState<TitleType>({
        sampleCode:'',
        profileName:'',
        layerName:'',
        star:0,
        end:0
    });
    const [detailHtml,setDetailHtml] = useState([]);
    const [editItem,setEditItem] = useState({} as any);
    const [visibleType,setVisibleType] = useState(false);
    const [maxSlider,setMaxSlider] = useState(1);
    const [minSlider,setMinSlider] = useState(1);
    const lookItem = async ()=>{
        dispatch({type:'common/updateShowLoading',payload:true});
        const item = props.editItem;
        if (!item) return;
        setEditItem(item);
        dispatch({
            type: 'common/closeDownFile'
        });
        if(item.profileID){
            const res = await getSoilLayer(item.profileID);
            console.log('res:=====', res);
            const arr = res.map(obj=>obj.depth).sort((a:any,b:any)=>a-b);
            const resData = res.find(e=>item.layerID==e.layerId);
            setDetail(resData.samples.filter(e=>e.sampleCode == item.sampleCode));
            setDetailTitle({
                sampleCode:item.sampleCode,
                profileName:item.profileName,
                layerName:resData.layer.toUpperCase(),
                star:resData.layerStartDepth,
                end:resData.layerEndDepth
            });
            arr.map((obj,idx)=>{
                if(resData?.depth == obj){
                    // console.log(idx);
                    let star = 0,end = 0;
                    for(let i = 0;i < idx; i++){
                        star += parseInt(arr[i]);
                    }
                    for(let i = 0;i <= idx; i++){
                        end += parseInt(arr[i]);
                    }
                    console.log(star,end);
                    // setMinSlider(star+1);
                    setMaxSlider(end);
                    if(star!=0){
                        setMinSlider(star+1);
                    }else{
                        setMinSlider(star);
                    }
                }
            });
            setVisible2(true);
        }
        dispatch({type:'common/updateShowLoading',payload:false});
    };

    const dataFormat = (obj)=>{
        return moment(obj).format('DD MMM YYYY');
    };
    useEffect(()=>{
        console.log(props.editItem,props.visible);
        if(props.editItem!=undefined && props.visible){
            lookItem();
        }
    },[props.editItem, props.visible]);

    useEffect(() => {
        const htm:React.ReactNode = <></>;
        const arr = [];
        detail.map((obj,idx)=>{
            console.log(obj);
            arr.push (
                <div key={idx}>
                    <Row justify="center" align="middle">
                        <Col flex={1} style={{padding:'20px'}}>
                            <h4 className='blod'>Sampling Date</h4>
                            <p className='blueFont'>{dataFormat(obj.sampleDate)}</p>
                        </Col>
                        <Col flex={1} style={{padding:'20px'}}>
                            <h4 className='blod'>Sample Taken</h4>
                            <p className='blueFont'>{obj.takenByName}</p>
                        </Col>
                        <Col flex={1} style={{padding:'20px'}}>
                            <h4 className='blod'>Analysed by</h4>
                            <p className='blueFont'>{obj.analysedByName}</p>
                        </Col>
                        <Col flex={1} style={{padding:'20px'}}>
                            <h4 className='blod'>Internal Sample ID</h4>
                            <p className='blueFont'>{obj.sampleCode}</p>
                        </Col>
                        <Col flex={1} style={{padding:'20px'}}>
                            <h4 className='blod'>External Sample ID</h4>
                            <p className='blueFont'>{obj.externalSampleID}</p>
                        </Col>
                    </Row>
                    <Content style={{ backgroundColor: '#fff' }}>
                        <Table
                            className='NoRadius'
                            rowKey={record => record.propMeasurementID}
                            columns={columns2}
                            dataSource={obj.propertyValues}
                            pagination={false}
                        />
                    </Content>
                </div>
            );
        });
        // console.log(arr);
        setDetailHtml(arr);
    }, [detail]);
    const columns2 = [
        {
            title: ()=>(<h4 className="soliHeader" style={{fontSize:'14px'}}>{'Soil Properties'}</h4>),
            dataIndex: 'sampleCode',
            width:'45%',
            render: (text, record, index) => (
                <div className='default-table-height'>
                    {/* <Tag color="success">{record.propertyClass}</Tag> */}
                    <span style={{
                        background: record.propertyClass=='Physical'?'#C6E6FF':'#E7DDFC',
                        color: record.propertyClass=='Physical'?'#005693':'#643AAA',
                        padding:'3px 5px',borderRadius:'3px',margin:'0 10px',fontSize:'12px',fontWeight:600,lineHeight:'16px'
                    }}>{record.propertyClass.toUpperCase()}</span>
                    <span>{record.propertyName}</span>
                </div>
            )
        },
        {
            title: ()=>(<h4 className="soliHeader" style={{fontSize:'14px'}}>{'Value'}</h4>),
            width:'20%',
            render: (text, record, index) => {
                // console.log(record);
                return (
                    <>
                        <span className='blod'>{record.propertyValue}</span>
                        <span style={{paddingLeft:'10px',color: '#696F88'}}>{record.unitCode}</span>
                    </>
                );
            }
        },
        {
            title: ()=>(<h4 className="soliHeader" style={{fontSize:'14px'}}>{'Estimation Method'}</h4>),
            width:'35%',
            dataIndex: 'methodName',
        },
    ];
    const [visible2, setVisible2] = useState(false);
    const handleOk2 = () => {
        setVisible2(false);
    };
    const handleCancel2 = () => {
        setVisible2(false);
        props?.childChangeIsShowPreviewModal();
    };
    const handleCancel3 = async ()=>{
        props?.childChangeIsShowPreviewModal();
        setVisible2(false);
        dispatch({type:'common/updateShowLoading',payload:true});
        const res = await FetchanalysisDetail({sampleID:editItem.id});
        const resd = await getSoilLayer(editItem.profileID);
        const resData = resd.find(e=>editItem.layerID==e.layerId);
        setDetail(resData.samples);
        const sample = resData.samples.find(e=>e.sampleId == editItem.id);
        props.edit&&props.edit({...res,...{samples:sample}});
        dispatch({
            type: 'common/closeDownFile'
        });
        dispatch({type:'common/updateShowLoading',payload:false});
    };
    const downloadFile = async (type)=>{
        console.log(editItem);
        const date = moment().format('DD-MMM-YYYY');
        const userFileName= editItem.sampleCode+'_'+date + '_' +parseInt(String(Math.random() * 1000000)) + '.' + type;
        try {
            dispatch({type:'common/updateShowLoading',payload:true});
            const res = await DLAnalysisDetail({
                strProfileCode:editItem.profileCode,
                fileName:userFileName,
                strSampleCode:editItem.sampleCode,
                intLayerID:editItem.layerID,
                intSampleID:editItem.id,
                enumFileType:type,
            });
            dispatch({type:'common/updateShowLoading',payload:false});
        } catch (error) {
            dispatch({type:'common/updateShowLoading',payload:false});
        }
    };
    return (
        <div className="test">
            <Modal
                // getContainer={document.getElementById('down')}
                title="Choose file format"
                className='analysis-detail-modal'
                open={visibleType}
                style={{marginRight:100,top:300, borderRadius: '16px', overflow: 'hidden'}}
                centered={false}
                onCancel={e=> {
                    setVisibleType(false);
                    props.onCancel();
                }}
                footer={
                    <Button type="default" size='large' shape="round" onClick={e=>setVisibleType(false)}>
                        Cancel
                    </Button>
                }
                closeIcon={<SoilCloseIcon />}
            >
                <div className="template">
                    <div className="btns" onClick={e=>downloadFile('PDF')}>
                        <p className="icon"><DownloadPdf /></p>
                        <p className="text" style={{fontWeight:700}}>PDF</p>
                    </div>
                    <div className="btns" onClick={e=>downloadFile('XLSX')}>
                        <p className="icon"><DownloadXls /></p>
                        <p className="text" style={{fontWeight:700}}>XLS</p>
                    </div>
                </div>
                {/* <div className="template" style={{marginTop:20}}>
                    <div className="btns" onClick={e=>downloadFile('CSV')}>
                        <p className="icon"><DownloadCsv /></p>
                        <p className="text" style={{fontWeight:700}}>CSV</p>
                    </div>
                    <div className="btns" style={{border:0}}>
                    </div>
                </div> */}
            </Modal>
            <Modal
                title="Soil Analysis Preview"
                className='analysis-detail-modal'
                open={visible2}
                onOk={handleOk2}
                width='950px'
                onCancel={handleCancel2}
                closeIcon={<SoilCloseIcon />}
                footer={[
                    <IF show={
                        userInfo?.roleName!='Administrator'&&
                        (
                            userInfo?.roleName=='Reader'||
                            (
                                userInfo?.userId!=props.editItem?.userID&&
                                userInfo?.userId!=props.editItem?.publisherID
                            )
                        )} key="cancel">
                        <Button key="cancel" type="default" size='large' shape="round" onClick={handleCancel2}>
                            Cancel
                        </Button>
                    </IF>,
                    <IF show={
                        userInfo?.roleName=='Administrator'||
                        (
                            userInfo?.roleName!='Reader'&&
                            (
                                userInfo?.userId==props.editItem?.userID ||
                                userInfo?.userId==props.editItem?.publisherID
                            )
                        )} key="edit">
                        <Button key="edit" size='large' type="default" shape="round" onClick={handleCancel3} icon={ <SoilProfileEditProfileIcon /> }>
                            &nbsp;&nbsp;Edit Analysis
                        </Button>
                    </IF>,
                    <Button id='down' key="submit" size='large' type="primary" shape="round"
                        onClick={e=>{setVisibleType(true);props?.childChangeIsShowPreviewModal();}}>
                        Download
                    </Button>
                ]}
            >
                <h3 style={{marginBottom:'10px'}} className='blod'>{detailTitle?.sampleCode}</h3>
                <h3 style={{marginBottom:'15px'}}>
                    <span style={{fontWeight:400}}>Associated Soil Profile </span>
                    <span style={{fontWeight:700}}>{detailTitle?.profileName} </span>
                </h3>
                <h4 className='blod'
                    style={{background: '#DFE2E7',textAlign:'center',borderRadius:'8px 8px 0 0',padding:'3px 0'}}
                >{detailTitle?.layerName} ({detailTitle.star} – {detailTitle.end} cm)</h4>
                {/* {detailHtml.map((obj,idx)=>(<div key={idx}>{obj}</div>))} */}
                {detailHtml}

            </Modal>
        </div>
    );
};
export default DetailModel;